import { Component, OnInit } from '@angular/core';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { WebService } from '../shared/services/web.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { fadeIn } from '../../app/shared/animation/animation.component';
import { arch } from 'os';
import { cloneDeep } from 'lodash';




interface DataItem {
  user_id: number;
  first_name: string;
  // last_name: string;
  phone_number: string;
  roles: [RoleItem];
  email: string;
  image_path: string;
  last_updated: string;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
  colWidth?: string;
}
interface userFormItem {
  first_name: string;
  // last_name: string;
  phone_number: string;
  roles: [RoleItem];
  email: string;
  image_path?: string;
  user_id?: number; // Optional for update mode
}

interface RoleItem {
  role_id: number;
  role_name: string;
}

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html',
  styleUrls: ['./user-panel.component.css'],
  animations: [fadeIn],
})

export class UserPanelComponent implements OnInit {

    isLoading: boolean = false;
    isArchived: boolean = false;
    listOfColumns: ColumnItem[] = [
      // {
      //   name: 'First name',
      //   sortOrder: null,
      //   sortFn: (a: DataItem, b: DataItem) =>
      //     a.first_name.localeCompare(b.first_name),
      //   sortDirections: ['ascend', 'descend', null],
      // },
      // {
      //   name: 'Last name',
      //   sortOrder: null,
      //   sortFn: (a: DataItem, b: DataItem) =>
      //     a.last_name.localeCompare(b.last_name),
      //   sortDirections: ['ascend', 'descend', null],
      // },
      {
        name: 'Name',
        sortOrder: null,
        sortFn: (a: DataItem, b: DataItem) =>{
          const nameA = a.first_name || '';
          const nameB = b.first_name || '';
          return nameA.localeCompare(nameB);
        },

        sortDirections: ['ascend', 'descend', null],
        colWidth: '35%',
      },
      {
        name: 'Roles',
        sortOrder: null,
        // sortFn: (a: DataItem, b: DataItem) => {
        //   const nameA = a.role_name || '';
        //   const nameB = b.role_name || '';
        //   return nameA.localeCompare(nameB);
        // },

        sortFn: null,
        sortDirections: [],
        colWidth: '35%',


      },
      {
        name: 'Mobile number',
        sortOrder: null,
        sortFn: (a: DataItem, b: DataItem) => {
          const nameA = a.phone_number || '';
          const nameB = b.phone_number || '';
          return nameA.localeCompare(nameB);
        },
        colWidth: '200px',
        sortDirections: ['ascend', 'descend', null],
      },
      {
        name: 'Last updated',
        sortOrder: null,
        sortFn: (a: DataItem, b: DataItem) => {
          const nameA = a.last_updated || '';
          const nameB = b.last_updated || '';
          return nameA.localeCompare(nameB);
        },
        colWidth: '20%',
        sortDirections: ['ascend', 'descend', null],
      },

      // {
      //   name: 'Actions',
      //   sortOrder: null,
      //   sortFn: null,
      //   sortDirections: [],
      //   colWidth: '10%',

      // },
    ];
    sortOrder: NzTableSortOrder | null;
    sortFn: NzTableSortFn<DataItem> | null;
    categoryFilterList: any[];
    submitFlag: boolean = true;
    showLoad: boolean;
    filterVisible: boolean = false;
    archived: any;
    appliedFilters: any[];
    isUsedInLast30Days: any;
    searchTerm:string;
    userData: any[] = [];
    userDataRaw: any[] = [];
    checkedData: any[] = [];
    anyChecked: boolean = false;
    allChecked: boolean = false;
    updateMode: boolean = false;
    userForm: FormGroup;
    roleData: RoleItem[] = [];
    currentPage: number = 1;
    pageSize: number = 50;
    hasMore = true;
    totalUsers: number = 0;
    currentBrowserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    isVisible = false;
    confirmationText: string = ''; 
  isDeleteModalVisible = false;
  deleteConfirmationText = '';
  selectedUserId: number | null = null;
  multipleSelect: boolean = false;


  constructor(
    private webapi: WebService,
        private fb: FormBuilder,
        private notification: NzNotificationService,
        private modal: NzModalService,
  ) { 

    this.userForm = fb.group({
          user_id: [null], // Optional for update mode
          first_name: [null, [Validators.required]],
          // last_name: [null],
          roles: [[], [Validators.required]],
          phone_number: [{ value: null, disabled: true }, , [Validators.required]],
          email: [{ value: null, disabled: true }, , [Validators.required, Validators.email]],
        });
    this.getMetadata();
    this.getUsers({ filters: [] });
  }

  ngOnInit(): void {
  }
  getMetadata(): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        this.webapi
          .requestJson('getMetaData', {
            metadata: ['roles'],
          })
          .subscribe(
            (data) => {
              let response = JSON.parse(data.body);
              this.roleData = cloneDeep(response.data['roleCategory']);
              console.log('Role Data', this.roleData);
              resolve(); 
            },

            (error) => {
              var msg = error.headers.get('message');
              reject();
            }
          );
      });
    }
  
 
  getUsers({filters}){

    this.isLoading = true;
    this.showLoad = true;
 
    //Payload
    let obj = {
      request_page: this.currentPage,
      items_per_page: this.pageSize,
      search :this.searchTerm ? this.searchTerm : null,
      filters: {
        archive: this.isArchived ? 1 : 0,
      },
      timestamp: null,
      existing_users: this.userData.map((user) => user.user_id), // Send existing user IDs to avoid duplicates
    }


    this.webapi.requestJson('getPaginatedUsers', obj).subscribe(
      (data) => {
      
        var response = JSON.parse(data.body);
        console.log("Paginated User Response",response);

        //total users count and hasMore tag
        this.totalUsers = response.total_user_count;
      
        this.hasMore = this.userDataRaw.length < this.totalUsers && response.data.length == this.pageSize;

        //cleaning data
        let resData = response.data
          .filter((element) => element?.first_name?.trim()) // removes null, "", or spaces
          .map((element) => {
            element.checked = false;
            return element;
          });

        //add new paginated user data into userDataRaw
        this.userDataRaw = [...this.userDataRaw, ...resData];

        console.log("User Data",this.userDataRaw);
        this.userData = [...this.userDataRaw];
        //clone the array to trigger change detection
        this.userData = [...this.userData];
        this.isLoading = false;
        this.showLoad = false;
        this.currentPage = response.request_page + 1;
        this.refreshStatus();
      },
      (error) => {
        this.isLoading = false;
        this.showLoad = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      })
  }

  updateUserProfile(): void {
    
    this.isLoading = true;
    this.showLoad = true;
    const formValue = this.userForm.value;
    console.log("Form Value",formValue);
    const payload = {
      user_id: formValue.user_id || null, // Use user_id if available for update
      first_name: formValue.first_name,
      // last_name: formValue.last_name,
      role_id: formValue.roles|| []
    }
    console.log("this is payload",payload);
    this.webapi.requestJson('updateUserProfile', payload).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        console.log("Response from updateUser",response);
       
        if (response.code == 200) {
          this.createNotification('success', '', 'User updated successfully.');
          this.isLoading = false;
          this.showLoad = false;
          this.updateMode = false; // Reset update mode after successful update
          this.resetUpdateForm(); // Reset the form to its initial state
          
        } else {
          this.isLoading = false;
          this.showLoad = false;
          this.updateMode = false; // Reset update mode after successful update
          this.resetUpdateForm()
          this.createNotification('error', '', response.message || 'An error occurred while updating the user.');
        }
        this.currentPage = 1;
        this.hasMore = true;
        this.userDataRaw = [];
        this.userData = [];
        this.getUsers({ filters: [] });
        
      },
      (error) => {
        this.isLoading = false;
        this.showLoad = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
        console.error("Error in updateUserProfile", error);
      }

    );
  
  }

  checkAll(value: boolean): void {
    this.userData.forEach((data) => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.checkedData = [];
    console.log("User DAta inside refresh",this.userData  );
    this.userData.forEach((element) => {
      if (element.checked) {
        this.checkedData.push(element.user_id);
      }
    });
    this.anyChecked = this.userData.some((e) => e.checked);
    this.allChecked = this.userData.every((e) => e.checked);
  }

  deleteUser(userId: any = null, multi = false): void {

    this.isLoading = true;
    this.isVisible = false;
    this.showLoad = true;
    let obj = {
      user_ids: [userId],
    };
    if (multi) {
      obj.user_ids = [];
      obj.user_ids = this.checkedData;
    }

    

    console.log("Delete User Payload",obj);
    this.webapi.requestJson('deleteUserAccount', obj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        console.log("Response from deleteUser",response);
        this.isLoading = false;     
        this.showLoad = false;  
        // this.knowledgeBaseData = [...response.data];
        this.createNotification('success', '', 'Deletion successful.');
        this.currentPage = 1;
        this.hasMore = true;
        this.userDataRaw = [];
        this.userData = [];
        this.getUsers({ filters: [] });
        this.anyChecked = false;

      },
      (error) => {
        this.isLoading = false;
        this.showLoad = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }


  // open modal for selected row
  openDeleteModal(userId: number,multi = false): void {
    this.selectedUserId = userId;
    this.deleteConfirmationText = '';
    this.isDeleteModalVisible = true;
    this.multipleSelect = multi;
  }

  // cancel button
  handleDeleteCancel(): void {
    this.isDeleteModalVisible = false;
    this.selectedUserId = null;
    this.multipleSelect = false;
    this.deleteConfirmationText = '';
  }

  // delete button
  confirmDelete(): void {

    if (this.deleteConfirmationText === 'DELETE') {

      console.log('Deleting user with ID:', this.selectedUserId);
      console.log("this is multiple select", this.multipleSelect);

      // Call your delete API here
      this.deleteUser(this.selectedUserId, this.multipleSelect);

      //Reset modal state
      this.isDeleteModalVisible = false;
      this.selectedUserId = null;
      this.multipleSelect = false;
      this.deleteConfirmationText = '';
    }
  }
 
  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }
  onKeyUp(query: string): void {

    if (query) {
      // this.isLoading = true;
      let q: string;
      q = query.toLowerCase();
      const searchData = this.userDataRaw.filter((d) => {
        var found = false;
        if (
          (d.first_name && d.first_name.toLowerCase().includes(q)) ||
          (d.roles && this.findRoleName(d.roles,q)) ||
          (d.phone_number && d.phone_number.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.userData = searchData;
      this.userData = [...this.userData];
      // this.isLoading = false;
    } else {
      this.userData = [...this.userDataRaw];
    }
  }

  findRoleName(roleArr:[RoleItem],query:string): boolean {

    if(roleArr && roleArr.length > 0){
      const foundRole = roleArr.find((role) => role.role_name.toLowerCase().includes(query));
      return foundRole ? true : false ;
    }
    return false;

  }
  resetSearch() {
    if (this.searchTerm) {
      this.searchTerm = ''
      this.userData = [];
      this.userDataRaw = [];
      this.currentPage = 1;
      this.hasMore = true;
      this.getUsers({ filters: [] });

    }
  }

  applyFilters() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }

    // if (this.active) {
    //   this.appliedFilters.push({ key: 'status', values: ['1'] });
    //   this.filterVisible = false;
    //   this.isArchived = false;

    // }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
      this.isArchived = true;
    }
    else{
      this.isArchived = false;

    }
    this.currentPage = 1;
    this.hasMore = true;
    this.userDataRaw = [];
    this.userData = [];

    this.getUsers({ filters: this.appliedFilters });
    this.filterVisible = false;
  }

  onPopoverVisibleChange(visible: boolean) {
      if (!visible) {
        console.log('Popover is now hidden');
        this.clickFilter()
      } else {
        console.log('Popover is now visible');
      }
    }

  clickFilter() {
    this.filterVisible = false;
    if (this.appliedFilters && this.appliedFilters.length > 0) {
      this.archived = this.appliedFilters.some((filter) =>
        filter.values.includes('2')
      );
    } else {
      this.archived = false;
      this.isArchived = false;
    }
  }

  fillUserForm(user: DataItem): void {
    
    this.updateMode = true;
    this.userForm.patchValue({
      user_id: user.user_id, // Set the user_id for update mode
      first_name: user.first_name,
      // last_name: user.last_name,
      phone_number: user.phone_number,
      roles: user.roles ? user.roles.map((r)=> r.role_id) : [],//Role will assign letter
      email: user.email,
      image_path: user.image_path,
    });

    this.setOriginalFormValue();
}
  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.userForm.value };
  }
  confirmModal?: NzModalRef; // For testing by now
  showConfirm(hideQuickViewVisible: boolean = false): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        if (hideQuickViewVisible) {
          this.updateMode = !this.updateMode;
        }

        this.updateMode = false;
      },
    });
  }

  originalFormValue: any;
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    this.updateMode = false;
  }


  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.userForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (originalValue != currentValue) {
          return true; // Found a difference in form values
        }
      }
    }

    return false; // No differences found in form values
  }

  isFormNotEmpty(): boolean {
    if (this.userForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      for (const controlName in this.userForm.controls) {
        if (this.userForm.controls.hasOwnProperty(controlName)) {
          const control = this.userForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true; // Form control has a non-empty value
          }
        }
      }
      return false; // No form control has a non-empty value
    }
    // Check if any form control has a non-empty value
  }

  resetUpdateForm(): void {
    this.userForm.patchValue(this.originalFormValue);


  }

  applySearch(value: string): void {

    if (value.trim() || this.appliedFilters.length > 0) {
      this.searchTerm = value;

      this.currentPage = 1;
      this.userData = [];
      this.userDataRaw = [];
      this.hasMore = true;
      this.getUsers({ filters: [] });
    }

    console.log("this is value", value);
  }
  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;             // how far scrolled from top
    const scrollHeight = target.scrollHeight;       // full height of scrollable content
    const clientHeight = target.clientHeight;       // visible area

    console.log('Reached bottom?', scrollTop + clientHeight + 10 >= scrollHeight);
    console.log("this is selectedRootFolder");

    // this.hasMore = this.userDataRaw.length < this.totalUsers;


    if (scrollTop + clientHeight + 10 >= scrollHeight) {
      console.log('Reached bottom, loading next page...');
      if ((this.isLoading || this.showLoad) || !this.hasMore) {
        console.log("this is hasMore", this.hasMore);
        console.log("this is isLoading", this.isLoading);
        console.log("this is showLoad", this.showLoad);
        console.log('Loading or no more data, stopping');
        return;
      }
      else{

        this.getUsers({ filters: [] });
      }
    }
  }


}
